import styled from '@emotion/styled';
import {Button} from '@mui/joy';

import {ReactComponent as LanguageSVG} from '../../../assets/icons/ic_language.svg';

export const StyledButton = styled(Button)`
  min-height: 48px;
  min-width: 150px;
`;

export const IconLanguage = styled(LanguageSVG)`
  width: ${({theme}) => theme.icon.size.md};
  height: ${({theme}) => theme.icon.size.md};
  fill: ${({theme}) => theme.color.primary};
`;
